import script from "./CasinoGamesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CasinoGamesWidget.vue?vue&type=script&setup=true&lang=js"

import "./CasinoGamesWidget.vue?vue&type=style&index=0&id=41249caa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41249caa"]])

export default __exports__